/**
 * We have two types of seasons: academic year and summer.
 *
 * The types here are primarily used in the course catalog season page, which is at e.g.
 *   /courses/catalog/academic-year
 */

export interface SeasonObj {
	seasonId: string;
	slug: string;
	title: string;
}

export interface SeasonStrapi {
	data: {
		attributes: SeasonObj;
	};
}

enum Season {
	SUMMER = "summer",
	ACADEMIC_YEAR = "academic-year",
}

export default Season;

export const SeasonNames = {
	[Season.SUMMER]: "Summer",
	[Season.ACADEMIC_YEAR]: "Academic Year",
};
